/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const ArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Arrow Left"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M7.95 6.261a1.06 1.06 0 0 1 1.414.018.874.874 0 0 1-.02 1.306L5.46 11.077H21c.552 0 1 .413 1 .923s-.448.923-1 .923H5.46l3.885 3.492c.395.356.404.94.02 1.306a1.06 1.06 0 0 1-1.415.018l-5.647-5.077A.9.9 0 0 1 2 12c0-.25.11-.488.303-.662z"
      className="SVG"
    />
  </svg>
);

export const ArrowLeftIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'arrow-left-icon'}
      icon={ArrowLeft}
      {...props}
      size={size}
    />
  );
};
